import { render } from "./EmergencyAttachmentOffcanvas.vue?vue&type=template&id=bb4187d4&scoped=true&ts=true"
import script from "./EmergencyAttachmentOffcanvas.ts?vue&type=script&lang=ts"
export * from "./EmergencyAttachmentOffcanvas.ts?vue&type=script&lang=ts"

import "./EmergencyAttachmentOffcanvas.scss?vue&type=style&index=0&id=bb4187d4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb4187d4"]])

export default __exports__